import { useContext } from 'react';
import { SupportModalContext } from '../providers/SupportModalProvider';

function useSupportModal() {
  const { topic, showSupportModal, hideSupportModal } = useContext(SupportModalContext);
  return { topic, showSupportModal, hideSupportModal };
}

export default useSupportModal;
